import { atomWithStorage } from "jotai/utils";
import { OwnerPayConfig } from "../types";
import { DEFAULT_OWNER_PAY_CONFIG } from "../functions/cashflow.ts";

/**
 * How the owner pays themselves: which trailing figure to base the draw on, the
 * buffer target, the tax reserve percentage and the projection horizon.
 * Persisted in localStorage until the cash-flow API is wired.
 */
export const ownerPayConfigAtom = atomWithStorage<OwnerPayConfig>(
  "cashflow.ownerPayConfig",
  DEFAULT_OWNER_PAY_CONFIG,
  undefined,
  { getOnInit: true },
);
